<template>
  <div>
    <my-loader :loader="loader"></my-loader>
    <div class="align-center">
      <h1 class="mb-5">
        Участники программы клубный игрок
      </h1>
    </div>

    <div style="margin-bottom: 20px">
      <router-link :to="'/club_player'">
        <span class="d-block font-weight-semibold">Список запросов</span>
      </router-link>
    </div>

    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Поиск клиента"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        mobile-breakpoint="100"
        :headers="headers"
        :search="search"
        :items="client_list"
        item-key="request_pk"
        :loading="loading"
        class="elevation-1"
        loading-text="Загрузка данных"
      >
        <template #[`item.name`]="{ item }">
          <a @click="getClubPlayerClientHistory(item)">
            <span style="text-decoration: underline">{{ item.name }}</span>
          </a>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="clubplayer_popup"
      transition="dialog-top-transition"
    >
      <v-card v-if="active_player">
        <v-card-title>
          <span class="text-h5">{{ active_player.name }}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="topup_points_modal = true"
          >
            Начислить баллы
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col
              cols="6"
              sm="12"
              md="12"
            >
              <span class="text-h5">История запросов подарков</span>
              <v-simple-table v-if="client_history">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Дата запроса
                      </th>
                      <th class="text-left">
                        Дата выдачи
                      </th>
                      <th class="text-left">
                        Подарок
                      </th>
                      <th class="text-left">
                        Статус
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in client_history.gift_requests"
                      :key="index"
                    >
                      <td>
                        {{ item.created_at }}
                      </td>
                      <td>
                        {{ item.completed_at }}
                      </td>
                      <td>
                        {{ item.gift }}
                      </td>
                      <td>{{ item.status }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="12"
            >
              <span class="text-h5">История начисления баллов</span>
              <v-simple-table v-if="client_history">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Дата начисления
                      </th>
                      <th class="text-left">
                        Начисление/списание
                      </th>
                      <th class="text-left">
                        Начислено за...
                      </th>
                      <th class="text-left">
                        Баллы
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in client_history.points_history"
                      :key="index"
                    >
                      <td>
                        <template>
                          {{ item.date }}
                        </template>
                      </td>
                      <td>
                        <template v-if="item.type == 'UP'">
                          Начисление
                        </template>
                        <template v-else>
                          Списание
                        </template>
                      </td>
                      <td>
                        <template v-if="item.yc_data">
                          {{ item.yc_data.date | formatDateTime }} |
                          {{ item.yc_data.services[0].title }}
                        </template>
                        <template v-else-if="item.comment">
                          {{ item.comment }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <td>{{ item.points_amount }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="clubplayer_popup = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="topup_points_modal"
    >
      <v-card v-if="active_player">
        <v-card-title>
          <span class="text-h5">Ручное начисление баллов</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <template>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="topup_point"
                class="mt-5"
                outlined
                :rules="topup_pointRules"
                label="Кол-во баллов"
                required
              ></v-text-field>

              <v-textarea
                v-model="topup_description"
                class="mt-5"
                outlined
                :rules="topup_descriptionRules"
                label="Комментарий"
                required
              ></v-textarea>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="topupPoints()"
          >
            начислить
          </v-btn>
          <v-btn
            color="error"
            @click="reset()"
          >
            закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/api'
import MyLoader from '@/components/MyLoader.vue'

export default {
  components: { MyLoader },
  filters: {
    format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 '),
    formatDate(value) {
      const date = new Date(value)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      return `${day < 10 ? '0' : ''}${day}.${month < 10 ? '0' : ''}${month}.${year}`
    },
    formatDateTime(string) {
      const inputString = string
      const datePart = inputString.split(' ')[0]
      const timePart = inputString.split(' ')[1]
      const [year, month, day] = datePart.split('-')
      const [hour, minute, second] = timePart.split(':')
      const formattedDate = `${day}.${month}.${year} ${hour}:${minute}`

      return formattedDate
    },
  },
  data() {
    return {
      topup_points_modal: false,
      loading: false,
      loader: false,
      statusColor: {
        CREATED: 'info',
        PROCESSING: 'danger',
        COMPLETED: 'success',
      },
      headers: [
        {
          text: 'ID', value: 'user_id', align: 'start', width: '100',
        },
        { text: 'yc_id', value: 'yc_id' },
        { text: 'Имя', value: 'name' },
        { text: 'Телефон', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Баллы', value: 'club_player_points' },
      ],
      headers_rooms: [{ text: 'Номер', value: 'name', align: 'start' }],
      status: {
        CREATED: 'cоздан',
        PROCESSING: 'в обработке',
        COMPLETED: 'выдан',
      },
      errorMessages: '',
      client_list: [],
      client_history: null,
      search: '',
      clubplayer_popup: false,
      active_player: null,

      valid: true,
      topup_point: null,
      topup_pointRules: [v => !!v || 'Кол-во баллов обязательное поле', v => v <= 2 || 'Нельзя за один раз начислить больше 2х баллов'],
      topup_description: '',
      topup_descriptionRules: [v => !!v || 'Комментарий обязательное поле'],
    }
  },
  async created() {
    this.$watch(
      () => this.$route.params,
    )
  },
  async mounted() {
    this.getClubPlayerClients()
  },
  methods: {
    getClubPlayerClients() {
      this.loading = true
      try {
        Api.getClubPlayerClients().then(
          (event => {
            this.$set(this, 'loading', false)
            this.$set(this, 'client_list', event.users)
          }),
        )
      } catch (error) {
        console.log(error)
      }
    },
    getClubPlayerClientHistory(user) {
      this.loading = true
      this.active_player = user
      try {
        Api.getClubPlayerClientHistory(user.user_id).then(
          (event => {
            this.$set(this, 'loading', false)
            this.$set(this, 'client_history', event)
            this.$set(this, 'clubplayer_popup', true)
          }),
        )
      } catch (error) {
        console.log(error)
      }
    },
    topupPoints() {
      if (this.valid) {
        Api.ClubPlayerTopupPoints({
          user_pk: this.active_player.user_id,
          points_amount: this.topup_point,
          comment: this.topup_description,
        }).then(
          (event => {
            if (event.success) {
              this.$set(this, 'loading', false)
              this.$set(this, 'topup_points_modal', false)
              this.reset()
              this.getClubPlayerClientHistory(this.active_player)
            }
          }),
        )
      }
    },
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
      this.topup_points_modal = false
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style>
.filters {
  padding: 10px;
  background-color: #e6e6eb;
  border-radius: 5px;
  margin-bottom: 20px;
}

.href {
  text-decoration: underline;
  color: #2f65ae;
  cursor: pointer;
}

.label {
  font-size: 13px;
}

.search_calendar {
  margin-bottom: 20px;
  margin-top: 20px;
}

.mx-input {
  height: 48px;
}
</style>
